export default __webpack_public_path__ + "static/media/img.00acb89d.jpg";